import * as types from '../actions/actionTypes'
import { Businesses } from '../config/Helper';
import initialState from './initialState'

export default function setBlogBusiness(state = { business: 'all' }, action) {
    switch (action.type) {
        case types.SET_BLOG_BUSINESS:
            return {
                business: Businesses[action.business]
            }
        default:
            return state;
    }
}
